export const COMPANY = {
  name: "Crosstown Movers",
  phone: "(307) 265-8291",
  phoneTel: "+13072658291",
  email: "info@crosstownmoversllc.com",
  address: "4941 Highway St, Mills, WY 82604",
  city: "Mills",
  state: "WY",
  zip: "82604",
  website: "crosstownmoversllc.com",
  facebook: "https://www.facebook.com/crosstownmoversllc/",
  googleMaps:
    "https://www.google.com/maps/place/Cross%2BTown%2BMovers/@42.8252892,-106.3254347,12z/data=!4m6!3m5!1s0x8760a350ec114483:0x9ef28273b013dc19!8m2!3d42.8252892!4d-106.3254347!16s%2Fg%2F11h_6pzdq9?entry=ttu",
  hours: "Open 24 Hours",
  rating: 4.5,
  reviews: 60,
  founded: 1980,
  get yearsInBusiness() {
    return new Date().getFullYear() - this.founded;
  },
  serviceAreas: [
    "Casper, WY",
    "Mills, WY",
    "Evansville, WY",
    "Bar Nunn, WY",
    "Glenrock, WY",
    "Laramie, WY",
    "Riverton, WY",
    "Cheyenne, WY",
  ],
};

export const IMG = {
  hero: "https://images.pexels.com/photos/7464721/pexels-photo-7464721.jpeg",
  residential: "https://images.unsplash.com/photo-1467262942700-50d2d84cbaa9",
  packing: "https://images.unsplash.com/photo-1758523671531-75bd8a19e63b",
  commercial: "https://images.unsplash.com/photo-1772724316733-57e51acf7fac",
  whiteGlove: "https://images.pexels.com/photos/7464372/pexels-photo-7464372.jpeg",
  wyoming: "https://images.pexels.com/photos/32929232/pexels-photo-32929232.jpeg",
};

export const SERVICES = [
  {
    slug: "residential-moving-casper-wy",
    title: "Residential Moving",
    seoTitle: "Residential Moving Casper WY",
    short: "Careful home moves for apartments, condos, and family homes across Casper and Mills WY.",
    image: IMG.residential,
    icon: "Home",
  },
  {
    slug: "commercial-movers-casper-wy",
    title: "Commercial & Office Moving",
    seoTitle: "Commercial Movers Casper WY",
    short: "Efficient business relocations that minimize downtime for offices, clinics, and retail in Wyoming.",
    image: IMG.commercial,
    icon: "Building2",
  },
  {
    slug: "local-movers-mills-wy",
    title: "Local Movers",
    seoTitle: "Local Movers Mills WY",
    short: "Your trusted local moving company in Mills and Casper, serving Wyoming since 1980.",
    image: IMG.wyoming,
    icon: "MapPin",
  },
  {
    slug: "white-glove-moving-wyoming",
    title: "White-Glove Moving",
    seoTitle: "White Glove Moving Wyoming",
    short: "Premium handling for antiques, art, pianos, and high-value items with full protection.",
    image: IMG.whiteGlove,
    icon: "Sparkles",
  },
  {
    slug: "furniture-moving-heavy-lifting-casper",
    title: "Furniture Moving & Heavy Lifting",
    seoTitle: "Furniture Moving & Heavy Lifting Casper",
    short: "Disassembly, transport, and reassembly of large furniture and appliances across Wyoming.",
    image: IMG.packing,
    icon: "Sofa",
  },
  {
    slug: "packing-unpacking-services-wyoming",
    title: "Packing & Unpacking Services",
    seoTitle: "Packing and Unpacking Services Wyoming",
    short: "Full-service packing with quality materials — keep your belongings safe in transit.",
    image: IMG.packing,
    icon: "PackageCheck",
  },
  {
    slug: "office-movers-casper-wy",
    title: "Office Movers",
    seoTitle: "Office Movers Casper WY",
    short: "Organized office relocation for Wyoming businesses — secure, fast, and after-hours available.",
    image: IMG.commercial,
    icon: "Briefcase",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    location: "Cheyenne, WY",
    rating: 5,
    text:
      "Crosstown Movers made our Cheyenne to Casper move completely stress-free. The crew was on time, fast, and extremely professional. Best Wyoming moving company we've used — highly recommend!",
  },
  {
    name: "James R.",
    location: "Mills, WY",
    rating: 5,
    text:
      "Fair pricing and a polite team. They handled our heavy furniture and appliances without a single scratch. The Crosstown crew shows up ready to work — we'll use them again.",
  },
  {
    name: "Linda K.",
    location: "Laramie, WY",
    rating: 4,
    text:
      "Great communication from quote to moving day. They wrapped everything carefully, protected the floors, and got us settled into our new Laramie home before dinner.",
  },
  {
    name: "Michael D.",
    location: "Casper, WY",
    rating: 5,
    text:
      "Needed last-minute office movers in Casper — they showed up on time, moved everything quickly, and we were back in business the next morning. Could not be happier.",
  },
  {
    name: "Amanda T.",
    location: "Cheyenne, WY",
    rating: 5,
    text:
      "Honestly the best long-distance movers we've worked with in Wyoming. Clear quote, no surprises, careful handling. Worth every penny.",
  },
];

export const FAQS = [
  {
    q: "How much does moving cost in Wyoming?",
    a: "Local moves in Wyoming typically range from $300–$1,500 depending on home size, crew, and hours. Long-distance moves are quoted by weight and distance. Crosstown Movers gives transparent, upfront quotes with no hidden fees — call (307) 265-8291 or use our Instant Quote tool for a free estimate.",
  },
  {
    q: "Do you offer long-distance moving?",
    a: "Yes. Crosstown Movers handles long-distance and in-state moves across Wyoming and to neighboring states. Whether you're moving from Cheyenne to Casper, Laramie to Riverton, or out of state, our experienced crews use proper equipment, padding, and inventory tracking to keep your belongings safe end-to-end.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Absolutely. Crosstown Movers is fully licensed and insured for residential and commercial moves throughout Wyoming. Proof of insurance is included with every quote, and our crews carry full liability and cargo coverage on every job.",
  },
  {
    q: "How far in advance should I book movers?",
    a: "For best availability in Casper, Cheyenne, Mills, Laramie, and surrounding Wyoming areas, we recommend booking 2–4 weeks in advance. Peak season (May–September) fills up faster. We also handle last-minute and same-week moves whenever our schedule allows — we're open 24 hours.",
  },
  {
    q: "Do you provide packing services?",
    a: "Yes — full-service packing, partial packing, and unpacking are all available. We also offer specialty packing for fragile, high-value, and oversized items. Our team brings high-quality boxes, paper, bubble wrap, and custom materials to keep your belongings safe in transit.",
  },
  {
    q: "Do you move heavy furniture and appliances?",
    a: "Yes. Our Wyoming movers are trained in heavy lifting, appliance moving, and oversized-item transport. We handle pianos, safes, treadmills, refrigerators, and large furniture with professional equipment and the right number of crew members.",
  },
  {
    q: "What areas in Wyoming do you serve?",
    a: "We serve Casper, Mills, Cheyenne, Laramie, Evansville, Bar Nunn, Glenrock, Riverton, and the surrounding Wyoming areas. Long-distance in-state and out-of-state moves are also available — call (307) 265-8291 to confirm coverage for your route.",
  },
  {
    q: "Do you offer white-glove moving?",
    a: "Yes. Our white-glove service is built for premium homes and high-value items — fine art, antiques, electronics, and luxury furniture. We custom-wrap, pad, and transport every piece with extreme care, including in-home placement and unpacking.",
  },
];
